import { InjectionToken } from '@angular/core';
import { ErrorReportingConfig } from './types/error-reporting-config';

export const ERROR_REPORTING_CONFIG = new InjectionToken<ErrorReportingConfig>(
  'ErrorReportingConfig'
);
